module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('md-dialog', {
    ref: "freedisturb",
    staticClass: "free_disturb",
    attrs: {
      "md-close-on-esc": false,
      "md-click-outside-to-close": false
    }
  }, [_c('md-dialog-title', [_vm._v("Completar Registro")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("Recuerde completar su Registro comprando uno de los planes de Agenda Médica ON LINE.\n\n\n  ")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-raised md-size btn-primary pull-left",
    staticStyle: {
      "background-color": "#76be33",
      "color": "#ffffff",
      "line-height": "46px"
    },
    attrs: {
      "href": _vm.payLink,
      "target": "_blank"
    }
  }, [_c('md-icon', [_vm._v("shopping_cart")]), _vm._v(" Pagar en Linea\n                            ")], 1)], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "debtor",
    staticClass: "free_disturb",
    attrs: {
      "md-close-on-esc": true,
      "md-click-outside-to-close": true
    }
  }, [_c('md-dialog-title', [_vm._v("Usted se encuentra atrasado en sus pagos")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n      Usted adeuda "), _c('b', [_vm._v(_vm._s(_vm.financial.plan_owed) + " " + _vm._s(_vm.financial.is_anual ? "año(s)" : "mes(es)"))]), _vm._v("."), _c('br'), _vm._v("\n      Si ya realizo el pago simplemente refresque la pagina.\n\n\n  ")]), _vm._v(" "), _c('md-dialog-actions', {
    staticStyle: {
      "justify-content": "center !important"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-size btn-primary pull-left",
    staticStyle: {
      "background-color": "#76be33",
      "color": "#ffffff",
      "line-height": "46px"
    },
    nativeOn: {
      "click": function($event) {
        _vm.renewPlan()
      }
    }
  }, [_c('md-icon', [_vm._v("shopping_cart")]), _vm._v(" Pagar ahora\n                            ")], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a5f473e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 667
// module chunks = 1